<template>
  <div class="swiper-container" style="width:100%;height:276px;">
    <swiper :options="swiperOpt" ref="swiperRef">
      <swiper-slide v-for="(img, index) in factoryImgList" :key="index" style="height:276px;">
        <img :src="img.src" alt="" class="slide_img">
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import img1 from "@/assets/img/index-pic1.webp";
import img2 from "@/assets/img/index-pic2.webp";
import img3 from "@/assets/img/index-pic3.webp";
import img4 from "@/assets/img/index-pic4.webp";
import img5 from "@/assets/img/index-pic5.webp";
import img6 from "@/assets/img/index-pic6.webp";
import img7 from "@/assets/img/index-pic7.webp";
export default {
  // 数据
  data() {
    return {
      swiperOpt: {
        slidesPerView: 3,
        spaceBetween:10,
        loop: true,
        autoplay: { delay: 3000 },
        pagination: { el: '.swiper-pagination', clickable: true }
      },
      // 工厂图片数组
      factoryImgList: [
        { src: img1 },
        { src: img2 },
        { src: img3 },
        { src: img4 },
        { src: img5 },
        { src: img6 },
        { src: img7 },
      ]
    };
  },
  // 方法
  methods: {

  }
}
</script>
<style scoped>
.slide_img {
  /* 1. 宽度填满父容器 */
  width: 100%;
  /* 2. 高度自适应，不会拉伸图片 */
  height: 100%;
  /* 3. 超出部分裁剪，保持不变形（常用） */
  object-fit: cover;
  /* 4. 居中显示 */
  object-position: center;
  /* 消除图片底部默认3px留白 */
  display: block;
}
</style>
/* Add your styles here */